export const bankCardHeader = {
    autoForward: false,
};
